"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useLocalTheme = _interopRequireDefault(require("../../hooks/useLocalTheme"));
var _utils = require("../../utils/utils");
var _GroupSpecs = _interopRequireDefault(require("./ComparisonDataDisplaySubComponents/GroupSpecs"));
var _ComparisonDataDisplay = require("./ComparisonDataDisplay.styled");
var _SpecsHeader = _interopRequireDefault(require("./ComparisonDataDisplaySubComponents/SpecsHeader"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const ProxyDiv = _styledComponents.default.div``;
const ComparisonDataDisplay = _ref => {
  let {
    label,
    specs,
    displayedProducts,
    applyShowDifferences,
    onNoDiff
  } = _ref;
  const showAllProducts = displayedProducts.length >= 3;
  const [displayedSpecs, setDisplayedSpecs] = (0, _react.useState)(specs);
  const shouldAddTableBorders = (0, _useLocalTheme.default)(`comparison.addTableBorders`, false);
  const handleLargestNumericValues = (numericValue, label) => {
    var _result;
    let result = numericValue;
    if (label === 'memory' && typeof numericValue === 'string') {
      const sizesInBytes = numericValue.split(',').flat(2).map(_utils.convertToBytes);
      const maxBytes = Math.max(...sizesInBytes);
      // Convert the maximum value back to the original unit
      const maxValue = (0, _utils.convertBytesToMaxUnits)(maxBytes);
      return maxValue;
    }
    if (typeof numericValue === 'string' && numericValue !== null && numericValue !== void 0 && numericValue.includes('x')) {
      result = Math.max(...numericValue.split('x').map(number => parseFloat(number)));
    }
    if (result === '') return 0;
    // handle case when value contains strings and numbers
    result = typeof result !== 'number' && (_result = result) !== null && _result !== void 0 && _result.match(/\d+(\.\d+)?/g) ? numericValue.match(/\d+(\.\d+)?/g)[0] : numericValue;
    return result;
  };
  const checkDuplicateInArray = (value, array) => {
    const values = array.filter(val => val === null || val === void 0 ? void 0 : val.includes(value));
    return values.length > 1;
  };
  const handleLargestSpecValues = (spec, allValues) => {
    let largestNumericValue;
    if (spec.label === 'memory') {
      // get largest memory in each spec. largestNumericValue will be array contains largest number of all specs
      largestNumericValue = allValues.map(x => {
        let numericValue = x;
        numericValue = handleLargestNumericValues(numericValue, spec.label);
        return numericValue;
      });
      const sizesInBytes = largestNumericValue.map(_utils.convertToBytes);
      // get largest memory in all specs
      const maxBytes = Math.max(...sizesInBytes);
      const maxValueWithOriginalUnit = (0, _utils.convertBytesToMaxUnits)(maxBytes);
      largestNumericValue = maxValueWithOriginalUnit;
    } else if (spec.label === 'weight') {
      largestNumericValue = Math.min(...allValues.map(x => {
        let numericValue = x;
        numericValue = handleLargestNumericValues(numericValue, spec.label);
        return parseFloat(numericValue);
      }));
    } else {
      largestNumericValue = Math.max(...allValues.map(x => {
        let numericValue = x;
        numericValue = handleLargestNumericValues(numericValue, spec.label);
        return parseFloat(numericValue);
      }));
    }
    const ignoredLabels = ['Operating System', 'Sim Type'];
    // map on all specs values and add isLargest = true to the largest value.
    const specValues = {
      ...spec
    };
    displayedProducts.forEach(productId => {
      specValues.values[productId].forEach(value => {
        let numericValue = value === null || value === void 0 ? void 0 : value.text;
        numericValue = handleLargestNumericValues(numericValue, spec.label);
        if (parseFloat(numericValue) === parseFloat(largestNumericValue) && !checkDuplicateInArray(largestNumericValue, allValues) && !ignoredLabels.includes(spec.label)) {
          value.isLargest = true;
        }
        return value;
      });
    });
    return specValues;
  };
  const handleShowDifferencesDisplay = specs => {
    const diffSpecs = [];
    // get all values of specs for all product ex: get all memories of all products
    const getTexts = values => values.map(value => value.text);
    specs.filter(spec => spec.label !== 'color').forEach(spec => {
      const allValues = [];
      displayedProducts.forEach(productId => {
        const specValues = getTexts(spec.values[productId]);
        allValues.push(...specValues);
      });

      // check if all values are different
      if (!allValues.every(val => val == allValues[0])) {
        const finalSpec = handleLargestSpecValues(spec, allValues);
        diffSpecs.push(finalSpec);
      }
    });
    return diffSpecs;
  };
  const WrapperComponent = shouldAddTableBorders ? _ComparisonDataDisplay.GroupSpecsWrapper : ProxyDiv;
  (0, _react.useEffect)(() => {
    setDisplayedSpecs(applyShowDifferences ? handleShowDifferencesDisplay(specs) : [...specs]);
  }, [applyShowDifferences, specs]);
  (0, _react.useEffect)(() => {
    onNoDiff(!displayedSpecs.length);
  }, [displayedSpecs]);
  const shouldDisplayHeader = (0, _react.useMemo)(() => !!displayedProducts.map(displayedProduct => specs.map(spec => spec.values[displayedProduct])).flat(2).filter(specValue => specValue === null || specValue === void 0 ? void 0 : specValue.text).length, [displayedProducts, specs]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "GroupSpecsContainer"
  }, /*#__PURE__*/_react.default.createElement(_SpecsHeader.default, {
    shouldDisplayHeader: shouldDisplayHeader,
    label: label
  }), /*#__PURE__*/_react.default.createElement(WrapperComponent, {
    removeBorder: !(displayedSpecs !== null && displayedSpecs !== void 0 && displayedSpecs.length)
  }, displayedSpecs === null || displayedSpecs === void 0 ? void 0 : displayedSpecs.map((spec, index) => /*#__PURE__*/_react.default.createElement(_GroupSpecs.default, {
    label: label,
    spec: spec,
    key: 'group-specs' + index,
    index: index,
    displayedProducts: displayedProducts,
    showAllProducts: showAllProducts,
    applyShowDifferences: applyShowDifferences
  }))));
};
var _default = ComparisonDataDisplay;
exports.default = _default;